import styled from 'react-emotion';
import Button from './Button';
export const TrendButton = styled(Button) `
  background: ${({ inverted, theme }) => inverted ? theme.colors.white : theme.colors.black};
  color: ${({ inverted, theme }) => inverted ? theme.colors.black : theme.colors.white};
`;
export default TrendButton;
//# sourceMappingURL=TrendButton.js.map